import '../suppressed_email/suppressed_email_form_controller';
import { canPaginate } from '../../mixins/can_paginate';

angular
.module('app.views')
.config(($routeProvider) => {
    $routeProvider.when('/suppressed_emails', {
        template: require('./suppressed_emails.html'),
        controller: 'SuppressedEmailsController'
    });
})
.controller('SuppressedEmailsController', function($scope, $location, $modal, SuppressedEmail) {
    canPaginate($scope, $location);
    $scope.s || ($scope.s = 'email');
    $scope.loading = true;

    $scope.suppressedEmails = SuppressedEmail.query(_.pick($scope, 'q', 's', 'p'), function(data, getResponseHeader) {
        $scope.loading = false;
        const pagination = getResponseHeader('X-Pagination');
        return $scope.pagination = (pagination ? JSON.parse(pagination) : {});
    });

    $scope.create = () =>
        $modal.open({ template: require('../suppressed_email/suppressed_email_create_new_form.html'), controller: 'SuppressedEmailFormController', size: 'lg', backdrop: 'static' }).result.then(e => $scope.show(e));

    return $scope.show = e => $location.url(`/suppressed_emails/${e.email}`);
});


// WEBPACK FOOTER //
// ./views/suppressed_emails/suppressed_emails_controller.js